
import { computed, defineComponent, PropType, reactive, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import InputText from 'primevue/inputtext';
import type { FlowSettingsBulk } from '@/types/flow-settings';
import { ButtonGroup } from '@/components/flows/operators/shared';

export default defineComponent({
  name: 'FlowSettingsBulk',

  components: {
    InputText,
    ButtonGroup,
  },

  props: {
    settings: {
      type: Object as PropType<FlowSettingsBulk>,
      required: true,
    },
    validationErrors: {
      type: Object as PropType<Record<string, string[]>>,
      default: () => ({}),
    },
  },

  emits: ['update'],

  setup(props, { emit }) {
    const { t } = useI18n();

    // Local reactive copy of settings
    const localSettings = reactive<FlowSettingsBulk>({ ...props.settings });

    // Watch for external settings changes
    watch(() => props.settings, (newSettings) => {
      Object.assign(localSettings, newSettings);
    }, { deep: true });

    // Emit helpers
    const emitUpdate = (field: keyof FlowSettingsBulk, value: any) => {
      (localSettings as any)[field] = value;
      emit('update', { [field]: value });
    };

    const yesNoOptions = computed(() => [
      { value: 1, label: t('yes') },
      { value: 0, label: t('no') },
    ]);

    const setTrackSales = (value: number) => {
      emitUpdate('track_sales', value as 0 | 1);
    };

    return {
      t,
      localSettings,
      emitUpdate,
      yesNoOptions,
      setTrackSales,
    };
  },
});
